<!-- <mat-progress-spinner style="width: 100px;height: 100px;top: 50%;position: absolute;left: 45%;top: 35%;z-index: 1000;  opacity: 0.8;"
   [mode]="mode"
   [value]="spinnerValue">
</mat-progress-spinner>
<div  style="width: 577px; height: 420px; background: white; border-radius: 20px">
    <div
        style="width: 100%; text-align: center; color: #0E0E0E; font-size: 22px; font-family: Montserrat; font-weight: 700; line-height: 28.60px; letter-spacing: 0.04px; word-wrap: break-word">
        Issue Certificates</div>
    <div
        style="width: 100%; text-align: center; color: #999999; font-size: 16px; font-family: Montserrat; font-weight: 400; letter-spacing: 0.32px; word-wrap: break-word">
        Add positions, issue certificates, and proceed with result declaration.</div>
    <div
        style="width: 100%;margin-bottom: 10px; padding-left: 24px; padding-right: 24px; padding-top: 8px; padding-bottom: 8px; background: #FFF5D0; border-radius: 6px; justify-content: center; align-items: center; gap: 10px; display: inline-flex">
        <div
            style="text-align: center; color: #0E0E0E; font-size: 12px; font-family: Montserrat; font-weight: 500; line-height: 15.48px; letter-spacing: 0.02px; word-wrap: break-word">
            Once certificates are generated, it cannot be undone</div>
    </div>
    <div class="rectangle-parent7">
        <div class="group-child17"></div>
        <div class="frame-parent7">
            <div class="anisha-khandelwal-class-5-wrapper">
                <div class="anisha-khandelwal-class-5-container">
                    <p class="abhisumat-padmanabh">{{topEntry[0].user_name}}</p>
                    <p class="class-51">{{topEntry[0].user_grade}}</p>
                </div>
            </div>
            <img class="group-child18" alt="" [src]="topEntry[0].submission[0].url" />
        </div>
        <div class="group-parent7">
            <img class="group-child20" alt="" src="assets/public/group-1171277364.svg" />

            <b class="b1">1</b>
        </div>
        <div class="frame-wrapper7">
            <div class="vector-parent1">
                <img class="vector-icon7" alt="" src="assets/public/vector5.svg" />

                <div class="frame-child5"></div>
                <img class="vector-icon7" alt="" src="assets/public/vector6.svg" style="cursor: pointer;"
                    (click)="suffleEntry(0, 1)">
            </div>
        </div>
        <div class="group-child21"></div>
        <div class="frame-parent8">
            <div class="abhisumat-padmanabh-class-7-wrapper">
                <div class="anisha-khandelwal-class-5-container">
                    <p class="abhisumat-padmanabh">{{topEntry[1].user_name}}</p>
                    <p class="class-51">{{topEntry[1].user_grade}}</p>
                </div>
            </div>
            <img class="group-child18" alt="" [src]="topEntry[1].submission[0].url" />
        </div>
        <div class="group-child23"></div>
        <div class="frame-parent9">
            <div class="ganaraj-snehasis-class-8-wrapper">
                <div class="anisha-khandelwal-class-5-container">
                    <p class="abhisumat-padmanabh">{{topEntry[2].user_name}}</p>
                    <p class="class-51">{{topEntry[2].user_grade}}</p>
                </div>
            </div>
            <img class="group-child18" alt="" [src]="topEntry[2].submission[0].url" />
        </div>
        <div class="frame-wrapper8">
            <div class="vector-parent1">
                <img class="vector-icon7" alt="" src="assets/public/vector7.svg" style="cursor: pointer;"
                    (click)="suffleEntry(2, 1)">

                <div class="frame-child5"></div>
                <img class="vector-icon7" alt="" src="assets/public/vector8.svg" />
            </div>
        </div>
        <div class="frame-wrapper9">
            <div class="vector-parent1">
                <img class="vector-icon7" alt="" src="assets/public/vector9.svg" style="cursor: pointer;"
                    (click)="suffleEntry(1, 0)">

                <div class="frame-child5"></div>
                <img class="vector-icon7" alt="" src="assets/public/vector10.svg" style="cursor: pointer;"
                    (click)="suffleEntry(1, 2)">
            </div>
        </div>
        <div class="group-parent8">
            <img class="group-child20" alt="" src="assets/public/group-11712773641.svg" />

            <b class="b2">2</b>
        </div>
        <div class="group-parent9">
            <img class="group-child20" alt="" src="assets/public/group-11712773642.svg" />

            <b class="b2">3</b>
        </div>
    </div>
</div>
<div
    style="width: 100%; height: 100%; padding-left: 27px; padding-right: 27px; padding-top: 12px; padding-bottom: 12px; background: linear-gradient(0deg, #386AF6 0%, #386AF6 100%); border-radius: 80px; justify-content: center; align-items: center; gap: 10px; display: inline-flex; cursor: pointer;"
    (click)="generateAllCertificate()">
    <div
        style="color: white; font-size: 14px; font-family: Montserrat; font-weight: 600; line-height: 30px; word-wrap: break-word">
        Declare Result</div>
</div> -->
<!-- <ng-container *ngIf="handleEvent">
    <app-certifcate-genarate [topEntry]="topEntry" [competitionDetail]="competitionDetail" [certiIndex]="certiIndex" (eventEmitter)="handleEvent($event)"></app-certifcate-genarate>
</ng-container> -->


<div style="width:30vw">
    <div style="width: 100%; text-align: center; color: #0E0E0E; font-size: 22px; font-family: Montserrat; font-weight: 700; line-height: 28.60px; letter-spacing: 0.04px; word-wrap: break-word">
        Declare Result</div>
    <div style="width: 100%; text-align: center; color: #999999; font-size: 16px; font-family: Montserrat; font-weight: 400; letter-spacing: 0.32px; word-wrap: break-word">
        Check positions and proceed with result declaration time.</div>
    <div
        style="width: 100%;margin-bottom: 10px; padding-left: 24px; padding-right: 24px; padding-top: 8px; padding-bottom: 8px; background: #FFF5D0; border-radius: 6px; justify-content: center; align-items: center; gap: 10px; display: inline-flex">
        <div
            style="text-align: center; color: #0E0E0E; font-size: 12px; font-family: Montserrat; font-weight: 500; line-height: 15.48px; letter-spacing: 0.02px; word-wrap: break-word">
            Once Winners are declared, it cannot be undone</div>
    </div>
    <!-- <div *ngFor="let entry of topEntry" fxLayout="row">


    </div> -->
    <div class="art-list-container">
        <div class="scrollable-content">
        <mat-card *ngFor="let entry of topEntry; let i = index" class="art-card">
          <div class="art-content">
            <img [src]="entry.submission[0].url" alt="Artwork" class="art-image">
            <div class="art-info">
                <div
                style="color: #0E0E0E; font-size: 16px; font-family: Montserrat; font-weight: 600; line-height: 16px; word-wrap: break-word">
                {{entry?.user_name}}</div>
                              <div style="color: #999999; font-size: 12px; font-family: Montserrat; font-weight: 500; line-height: 12px; word-wrap: break-word">{{entry.user_grade}}</div>
            </div>
            <!-- <div class="art-rank">
              <span>{{ i + 1 }}</span>
            </div> -->
          </div>
        </mat-card>
        </div>
        <!-- <button mat-raised-button color="primary" class="confirm-button">Confirm</button> -->
      </div>
      <app-scedule-dialog [winnerEntries]="topEntry" [competitionId]="competitionId"></app-scedule-dialog>
</div>

